<template>
    <div class="infoengine industry-factor-page">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-5 filter-title-section">
                    <h2>Industry Factor</h2>
                </div>
                <div class="col-md-7 text-right">
                    <div class="row">
                        <div class="col-md-6">
                            <base-search
                                placeholder="Search industry"
                                @keyword="getKeyword"
                            ></base-search>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-4">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                        :class="
                                            loading && showPageLoader
                                                ? 'disabled'
                                                : ''
                                        "
                                        @click="apply"
                                    >
                                        <span class="btn-text">Apply</span>
                                        <span class="loader"></span>
                                    </button>
                                </div>
                                <div class="col-md-8">
                                    <b-button
                                        type="button"
                                        variant="secondary"
                                        class="secondary-add-btn"
                                        @click="openPopup()"
                                    >
                                        <span class="btn-text"
                                            >+ Add Industry</span
                                        >
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            :class="[
                'table-section',
                'tablet-table-xxs-min-width',
                'industry-table',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
            :style="{ overflow: 'visible' }"
        >
            <b-table
                :items="data"
                :fields="fields"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
                <template slot="workTypeImpacts" slot-scope="data">
                    <a href="#" class="work-impact">
                        <span>View Work Type Impact</span>
                        <i class="icon-caret-right"></i>
                        <div class="custom-popover">
                            <ul>
                                <li
                                    v-for="(
                                        workTypeImpact, index
                                    ) in data.item.workTypeImpacts.filter(
                                        (v) => {
                                            return (
                                                v.workType.status == 'active' &&
                                                v.workType.isIndustrial == true
                                            )
                                        }
                                    )"
                                    :key="index"
                                >
                                    <label
                                        >{{ workTypeImpact.workType.title }}
                                    </label>
                                    <span :class="workTypeImpact.ranking">
                                        {{
                                            workTypeImpact.ranking | capitalize
                                        }}</span
                                    >
                                </li>
                            </ul>
                        </div>
                    </a>
                </template>
                <template slot="status" slot-scope="data">
                    <div class="action-review">
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('add-industry-popup')
                            "
                        ></base-action>
                        <!-- if action archive -->
                        <base-action
                            :icon="
                                data.value == 'active'
                                    ? 'icon-trash'
                                    : 'icon-done'
                            "
                            :label="
                                data.value == 'active' ? 'Archive' : 'Activate'
                            "
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('status-update-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>

        <!-- Get list records -->
        <base-records
            path="configurations/industries"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>
        <!-- Add industry popup -->
        <add-industry-popup
            :title="title"
            :button-text="buttonText"
            :work-type-list="workTypeList"
        ></add-industry-popup>
        <!-- Archive popup -->
        <archive-popup
            title="Archive Industry Factor"
            description="Are you sure you want to archive this industry factor? You can re-activate it later."
        ></archive-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import addIndustryPopup from '@/components/popups/AddIndustryPopup.vue'
import archivePopup from '@/components/popups/ArchivePopup.vue'
import resource from '@/api/resource'
const workTypeResource = new resource('configurations/work-types')

export default {
    components: {
        addIndustryPopup,
        archivePopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            workTypeList: [],
            // Industry fields
            fields: [
                {
                    key: 'code',
                    label: 'Industry Code',
                    class: 'text-center w-150px',
                    sortable: true,
                },
                {
                    key: 'title',
                    label: 'Industry Title',
                    sortable: true,
                    class: 'w-300px',
                },
                {
                    key: 'workTypeImpacts',
                    label: 'WORK TYPE IMPACT',
                    sortable: false,
                },
                {
                    key: 'status',
                    label: 'ACTION',
                    class: 'two-list',
                },
            ],
            title: '',
            buttonText: '',
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'code',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method

        async openPopup() {
            let { data } = await workTypeResource.list({
                dataSegmentId: this.query.dataSegmentId,
                sortBy: 'code',
                sortOrder: 'asc',
                isIndustrial: true,
            })

            this.workTypeList = []
            if (data) {
                let $this = this
                data.data.forEach(function (val, index) {
                    if (val.status == 'active' && val.isIndustrial == true) {
                        $this.workTypeList.push(data.data[index])
                    }
                })
            }
            this.$bvModal.show('add-industry-popup')
        },
    }, // End of Component > mounted
} // End of export default
</script>
<style lang="scss">
.industry-table {
    .table {
        overflow: visible;
    }
}
.industry-table table tbody tr:last-child .work-impact .custom-popover {
    bottom: -20px !important;
}
</style>
